<div class="modal-fator-ecg">
    <div class="modal-header">
        <h4 class="modal-title">{{inclusao ? 'Inclusão' : 'Edição'}} de Fator de ECG</h4>
        <button _ngcontent-jop-c162="" type="button" aria-label="Close" class="btn-close float-end" (click)="fechar()"></button>
    </div>
    <div class="modal-body">
        Está ação irá excluir a linha selecionada.
        <br />
        <br />
        Você confirma?
        <br />
    </div>
    <div class="modal-footer">
        <button class="btn btn-success" (click)="salvar()">Sim</button>
        <button class="btn btn-danger" (click)="cancelar()">Não</button>
    </div>
</div>
